import { Route, Routes, useParams } from 'react-router-dom';
import { useGetAlbumQuery } from './albums.api';
import { TabBar } from 'shared-components';
import { Form } from 'formik';
import { AlbumDetails } from './album-details';
import { AlbumAlbums } from './album-albums';
import { AlbumImages } from './album-images';
import { Card, CardContent } from 'shared-components';

export const AlbumForm = () => {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, isFetching } = useGetAlbumQuery(id as string);
  //const [update, { isLoading: isUpdating }] = useUpdateOrderMutation();

  if (isLoading || isFetching) {
    return <span>loading...</span>;
  }

  if (!data) return <span>Album not found</span>;

  return (
    <Card>
      <CardContent>
        <TabBar
          tabs={[
            { display: 'Details', link: '', endMatch: true },
            { display: 'Albums', link: 'albums' },
            { display: 'Images', link: 'images' },
          ]}
        />
      </CardContent>
      <Form>
        <Routes>
          <Route index element={<AlbumDetails album={data} />} />
          <Route path="albums" element={<AlbumAlbums album={data} />} />
          <Route path="images" element={<AlbumImages album={data} />} />
        </Routes>
      </Form>
    </Card>
  );
};
